/* IMPORT */
/* MAIN */
const NOOP_PROMISE_LIKE = {
    then: (fn) => {
        fn();
    }
};
/* EXPORT */
export { NOOP_PROMISE_LIKE };
